import { GetConsultantAvailabilityFormQuery } from "@graphql";
import { AvailabilityCalendarEvent, UnderScoreColor } from "@bonliva-crm/ui";

export const mapGetConsultantAvailabilityFormQuery = (
  data: GetConsultantAvailabilityFormQuery
): AvailabilityCalendarEvent[] => {
  return [
    ...data.consultantById.Availability.weeks.map((x) => ({
      start: new Date(x),
      end: new Date(x),
      color: UnderScoreColor.Primary
    })),
    ...data.bookingWeeksByConsultant.map((x) => {
      return {
        start: new Date(x.Week),
        end: new Date(x.Week),
        color: UnderScoreColor.DashedGreen
      };
    }),
    ...data.consultantOpportunityByConsultantId
      .flatMap((x) => {
        return x.weeks;
      })
      .unique()
      .map((x) => {
        return {
          start: new Date(x),
          end: new Date(x),
          color: UnderScoreColor.Blue
        };
      })
  ];
};
